export default __webpack_public_path__ + "static/media/home-decor-img-19.26966ab9.jpg";